const common: Record<string, string> = {
    to: '-',
};

export default common;